import { BudgetActionTypes } from '@bridebook/web/lib/budget/action-types';
import type { TCostSerialized } from '@bridebook/web/lib/weddings/types';

export const onFirebaseBudget = (costs: Record<string, TCostSerialized>) => ({
  type: BudgetActionTypes.ON_FIREBASE_BUDGET,
  payload: costs,
});
